import { createAsyncThunk } from '@reduxjs/toolkit';

import { IUser } from '.';
import { AdminApiPaths } from '../../dataProvider/APIPaths';
import APIDataProvider from '../../dataProvider/APIDataProvider';

const UsersApiDataProvider = new APIDataProvider<IUser>();

export const adminGetUserById = createAsyncThunk(
  '/admin/users/id',
  async (id: string) => {
    const path = `${AdminApiPaths.users}/${id}`;

    const response = await UsersApiDataProvider.getById(path);

    return response.data;
  }
);

export default adminGetUserById;
